module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ../~/@aws-amplify/core/~/aws-sdk/apis/sts-2011-06-15.paginators.json
// module id = 518
// module chunks = 0